import { render } from "./navigation.vue?vue&type=template&id=79473b05&scoped=true&lang=pug"
import script from "./navigation.vue?vue&type=script&setup=true&lang=js"
export * from "./navigation.vue?vue&type=script&setup=true&lang=js"

import "./navigation.vue?vue&type=style&index=0&id=79473b05&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79473b05"]])

export default __exports__